/* WBK-Datenlader (Berater-Umbau S5, 28.10.2026)
 * Ersetzt die frühere statische Datei mit Preisen und Gerätedaten.
 * Die Gerätedaten kommen live aus den Shopify-Metafeldern über die Datenvorlage
 * templates/collection.wbk-daten.liquid (feste Feldliste, noindex). Kein Fremdserver, kein Schlüssel.
 * Nutzung: window.wbkDatenLaden() liefert ein Promise mit der Liste der Geräte-Einträge. */
(function () {
  // Sammlung "Wärmebildkamera" (alle Wärmebild-Geräte, mehr als 250 Produkte -> Daten kommen seitenweise, 250 je Seite)
  var DATEN_URL = '/collections/waermebildkamera?view=wbk-daten';
  var promise = null;
  function seite(n) {
    return fetch(DATEN_URL + (n > 1 ? '&page=' + n : ''), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('wbk-daten');
        if (!el) throw new Error('Datenblock fehlt');
        return JSON.parse(el.textContent);
      });
  }
  window.wbkDatenLaden = function () {
    if (!promise) {
      promise = seite(1)
        .then(function (d1) {
          var jobs = [Promise.resolve(d1)];
          for (var n = 2; n <= (d1.seiten || 1); n++) jobs.push(seite(n));
          return Promise.all(jobs);
        })
        .then(function (seiten) {
          var alle = [];
          seiten.forEach(function (d) { alle = alle.concat(d.geraete || []); });
          if (!alle.length) throw new Error('Leere Antwort');
          return alle;
        });
    }
    return promise;
  };
  // Für die Vergleichsseite: Daten als Objekt je Schlüssel (frühere Form von WBK_DATA)
  var MARKEN = ['Nocpix', 'HIKMICRO', 'ThermTec', 'Pulsar', 'Pixfra', 'PARD', 'LEICA', 'Nitehog'];
  function markeNorm(v) {
    var l = (v || '').toLowerCase();
    for (var i = 0; i < MARKEN.length; i++) { if (MARKEN[i].toLowerCase() === l) return MARKEN[i]; }
    return v || 'Sonstige';
  }
  window.wbkDatenAlsObjekt = function () {
    return window.wbkDatenLaden().then(function (liste) {
      var o = {};
      liste.forEach(function (e) {
        var k = Object.assign({}, e, { brand: markeNorm(e.brand) });
        // Doppellinse/Ausführung: Anzeigename unterscheidbar machen
        if (e.ausfuehrung) {
          k.title = e.title + ' (' + (/ausführung/i.test(e.ausfuehrung) ? e.ausfuehrung : 'Linse ' + e.ausfuehrung) + ')';
        }
        o[e.key] = k;
      });
      window.WBK_DATA = o;
      return o;
    });
  };
})();

/* ── Hinweistexte nach Forseti (28.10.2026, Wortlaut zur Freigabe durch Alexander) ──
 * Ergänzt die Vergleichstabelle (Berater-Texte stehen in wbk-berater.js).
 * Technische Schuld: gehört später in wbk-berater.js bzw. wbk-vergleich.js (Aufräumen nach der Veröffentlichung). */
(function () {
  var KURZ = '<b>Reichweiten sind Richtwerte:</b> eigene Berechnung nach den Johnson-Kriterien bei guten Bedingungen (Zielgröße Rotwild 0,9 m, Rehwild 0,5 m), nicht 1:1 vom Hersteller übernommen. Die Herstellerangabe steht zur Information daneben; sie beruht oft auf anderen Annahmen. Bei Regen, Nebel oder geringem Temperaturunterschied zeigen Geräte mit niedrigem NETD-Wert meist deutlich mehr Details.';
  var UEBER = 'Unser Rechenwert liegt bei diesem Gerät über der Herstellerangabe.';
  function nf(n) { return Number(n).toLocaleString('de-DE'); }
  function ueber15(det, m) { return !!(det && m && (det - m) / m >= 0.15); }

  // ---------- Vergleichsseite (nachträglich in die erzeugte Tabelle) ----------
  function vergleichTexte() {
    var root = document.getElementById('wbk-vergleich-root');
    if (!root || typeof MutationObserver === 'undefined') return;
    var busy = false;
    function ergaenzen() {
      if (busy) return; busy = true;
      try {
        var tab = root.querySelector('.wbk-vgl__table');
        if (tab && !tab.getAttribute('data-hinweis')) {
          tab.setAttribute('data-hinweis', '1');
          var cols = Array.prototype.map.call(tab.querySelectorAll('thead .wbk-vgl__action'), function (e) { return (window.WBK_DATA || {})[e.getAttribute('data-handle')] || {}; });
          var rows = tab.querySelectorAll('tbody tr.wbk-vgl__row');
          Array.prototype.forEach.call(rows, function (tr) {
            var l = tr.querySelector('.wbk-vgl__td-label'); if (!l) return;
            var t = l.textContent.trim();
            if (t === 'Detektion') {
              l.textContent = 'Detektion (Rotwild) · berechnet nach Johnson-Kriterien';
              var n = document.createElement('tr'); n.className = 'wbk-vgl__row';
              var h = '<td class="wbk-vgl__td-label">Herstellerangabe (Detektion)</td>';
              cols.forEach(function (p) {
                var s = p.specs || {}, m = s.herstellerangabe_m, det = (p.calc || {}).detektion_m;
                h += '<td class="wbk-vgl__td-val">' + (m ? nf(m) + ' m' + (p.herstellerangabe_bezug ? ' (' + String(p.herstellerangabe_bezug).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }) + ')' : '') : 'nicht angegeben') + (ueber15(det, m) ? '<br><small>' + UEBER + '</small>' : '') + '</td>';
              });
              n.innerHTML = h; tr.parentNode.insertBefore(n, tr.nextSibling);
            } else if (/^(Erkennung|Ansprechen)/.test(t)) { l.textContent = t + ' · berechnet¹'; }
          });
          var fn = root.querySelector('.wbk-vgl__footnote');
          if (fn) fn.innerHTML = '¹ berechnet nach Johnson-Kriterien. ' + KURZ;
        }
      } finally { busy = false; }
    }
    new MutationObserver(ergaenzen).observe(root, { childList: true, subtree: true });
    ergaenzen();
  }
  function start() {
    vergleichTexte();
    if (window.wbkDatenLaden && document.querySelector('.wbk-seo-intro__h1 .wbk-model-count')) {
      window.wbkDatenLaden().then(function (l) {
        var u = {}; l.forEach(function (e) { u[e.url] = 1; });
        var h = document.querySelector('.wbk-seo-intro__h1');
        if (h) h.innerHTML = 'Wärmebildkamera Vergleich für die Jagd – <span class="wbk-model-count">' + Object.keys(u).length + '</span> Modelle im Vergleich';
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
